import React, { useEffect, useState } from 'react'
import { Container, FormContainer } from './styled'
import { useParams } from 'react-router-dom'
import InternalHeader from '../../general/internalHeader/view'
import { getEvents } from 'api'
import coworking from 'assets/images/coworking.jpg'
import noAvatar from '../../../../assets/images/no-avatar.png'
import EventForm from '../eventForm/view';

const EventAdmin = () => {

  const params = useParams()
  const { slug } = params
  const [,setEvents] = useState([])
  
  function getEventInfo() {
    getEvents(slug).then(r => {
      setEvents(r.events)
    })
      .catch(console.error)
  }


  function headerActionMethod() {
  }

  useEffect(() => {
    getEventInfo(true)
  }, [])

  const avatar = noAvatar
  return (
    <Container>
      <InternalHeader title={'New event'} subtitle={''} avatar={avatar} background={coworking} actionTitle='Save event' actionMethod={headerActionMethod} />
      <FormContainer>
        <EventForm />
      </FormContainer>
    </Container>
  )
}

EventAdmin.propTypes = {}

export default EventAdmin
